// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/booking/v1/booking.proto (package fingertip.creator.booking.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { AcceptBookingRequestRequest, AcceptBookingRequestResponse, CancelBookingPublicRequest, CancelBookingPublicResponse, CompleteBookingRequest, CompleteBookingResponse, ConfirmBookingRequestPublicRequest, ConfirmBookingRequestPublicResponse, CreateBookingPublicRequest, CreateBookingPublicResponse, CreateBookingRequest, CreateBookingResponse, CreateExternalCalendarEventRequest, CreateExternalCalendarEventResponse, DeclineBookingRequestRequest, DeclineBookingRequestResponse, DeleteBookingRequest, DeleteBookingResponse, DeleteExternalCalendarEventRequest, DeleteExternalCalendarEventResponse, GetBookingAssignmentOptionsRequest, GetBookingAssignmentOptionsResponse, GetBookingConfigPublicRequest, GetBookingConfigPublicResponse, GetBookingConfigRequest, GetBookingConfigResponse, GetBookingPaymentDetailsPublicRequest, GetBookingPaymentDetailsPublicResponse, GetBookingPublicRequest, GetBookingPublicResponse, GetBookingRequest, GetBookingRequestsRequest, GetBookingRequestsResponse, GetBookingResponse, GetBookingsInRangeRequest, GetBookingsInRangeResponse, GetBookingsRequest, GetBookingsResponse, GetCustomBookingSelectionTokenRequest, GetCustomBookingSelectionTokenResponse, GetCustomerBookingsRequest, GetCustomerBookingsResponse, GetExternalCalendarEventsInRangeRequest, GetExternalCalendarEventsInRangeResponse, RejectBookingRequest, RejectBookingResponse, RescheduleBookingRequest, RescheduleBookingResponse, UpdateBookingPropertyRequest, UpdateBookingPropertyResponse, UpdateBookingRequest, UpdateBookingResponse, VerifyCustomBookingRequest, VerifyCustomBookingResponse } from "./booking_pb.js";

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingConfig
 */
export const getBookingConfig = {
  localName: "getBookingConfig",
  name: "GetBookingConfig",
  kind: MethodKind.Unary,
  I: GetBookingConfigRequest,
  O: GetBookingConfigResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingConfigPublic
 */
export const getBookingConfigPublic = {
  localName: "getBookingConfigPublic",
  name: "GetBookingConfigPublic",
  kind: MethodKind.Unary,
  I: GetBookingConfigPublicRequest,
  O: GetBookingConfigPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookings
 */
export const getBookings = {
  localName: "getBookings",
  name: "GetBookings",
  kind: MethodKind.Unary,
  I: GetBookingsRequest,
  O: GetBookingsResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingRequests
 */
export const getBookingRequests = {
  localName: "getBookingRequests",
  name: "GetBookingRequests",
  kind: MethodKind.Unary,
  I: GetBookingRequestsRequest,
  O: GetBookingRequestsResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingsInRange
 */
export const getBookingsInRange = {
  localName: "getBookingsInRange",
  name: "GetBookingsInRange",
  kind: MethodKind.Unary,
  I: GetBookingsInRangeRequest,
  O: GetBookingsInRangeResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.CreateExternalCalendarEvent
 */
export const createExternalCalendarEvent = {
  localName: "createExternalCalendarEvent",
  name: "CreateExternalCalendarEvent",
  kind: MethodKind.Unary,
  I: CreateExternalCalendarEventRequest,
  O: CreateExternalCalendarEventResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.DeleteExternalCalendarEvent
 */
export const deleteExternalCalendarEvent = {
  localName: "deleteExternalCalendarEvent",
  name: "DeleteExternalCalendarEvent",
  kind: MethodKind.Unary,
  I: DeleteExternalCalendarEventRequest,
  O: DeleteExternalCalendarEventResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetExternalCalendarEventsInRange
 */
export const getExternalCalendarEventsInRange = {
  localName: "getExternalCalendarEventsInRange",
  name: "GetExternalCalendarEventsInRange",
  kind: MethodKind.Unary,
  I: GetExternalCalendarEventsInRangeRequest,
  O: GetExternalCalendarEventsInRangeResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBooking
 */
export const getBooking = {
  localName: "getBooking",
  name: "GetBooking",
  kind: MethodKind.Unary,
  I: GetBookingRequest,
  O: GetBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingPublic
 */
export const getBookingPublic = {
  localName: "getBookingPublic",
  name: "GetBookingPublic",
  kind: MethodKind.Unary,
  I: GetBookingPublicRequest,
  O: GetBookingPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingPaymentDetailsPublic
 */
export const getBookingPaymentDetailsPublic = {
  localName: "getBookingPaymentDetailsPublic",
  name: "GetBookingPaymentDetailsPublic",
  kind: MethodKind.Unary,
  I: GetBookingPaymentDetailsPublicRequest,
  O: GetBookingPaymentDetailsPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.CreateBooking
 */
export const createBooking = {
  localName: "createBooking",
  name: "CreateBooking",
  kind: MethodKind.Unary,
  I: CreateBookingRequest,
  O: CreateBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.CreateBookingPublic
 */
export const createBookingPublic = {
  localName: "createBookingPublic",
  name: "CreateBookingPublic",
  kind: MethodKind.Unary,
  I: CreateBookingPublicRequest,
  O: CreateBookingPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.UpdateBooking
 */
export const updateBooking = {
  localName: "updateBooking",
  name: "UpdateBooking",
  kind: MethodKind.Unary,
  I: UpdateBookingRequest,
  O: UpdateBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.UpdateBookingProperty
 */
export const updateBookingProperty = {
  localName: "updateBookingProperty",
  name: "UpdateBookingProperty",
  kind: MethodKind.Unary,
  I: UpdateBookingPropertyRequest,
  O: UpdateBookingPropertyResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.RescheduleBooking
 */
export const rescheduleBooking = {
  localName: "rescheduleBooking",
  name: "RescheduleBooking",
  kind: MethodKind.Unary,
  I: RescheduleBookingRequest,
  O: RescheduleBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.DeleteBooking
 */
export const deleteBooking = {
  localName: "deleteBooking",
  name: "DeleteBooking",
  kind: MethodKind.Unary,
  I: DeleteBookingRequest,
  O: DeleteBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.AcceptBookingRequest
 */
export const acceptBookingRequest = {
  localName: "acceptBookingRequest",
  name: "AcceptBookingRequest",
  kind: MethodKind.Unary,
  I: AcceptBookingRequestRequest,
  O: AcceptBookingRequestResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.DeclineBookingRequest
 */
export const declineBookingRequest = {
  localName: "declineBookingRequest",
  name: "DeclineBookingRequest",
  kind: MethodKind.Unary,
  I: DeclineBookingRequestRequest,
  O: DeclineBookingRequestResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.ConfirmBookingRequestPublic
 */
export const confirmBookingRequestPublic = {
  localName: "confirmBookingRequestPublic",
  name: "ConfirmBookingRequestPublic",
  kind: MethodKind.Unary,
  I: ConfirmBookingRequestPublicRequest,
  O: ConfirmBookingRequestPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.CompleteBooking
 */
export const completeBooking = {
  localName: "completeBooking",
  name: "CompleteBooking",
  kind: MethodKind.Unary,
  I: CompleteBookingRequest,
  O: CompleteBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.CancelBookingPublic
 */
export const cancelBookingPublic = {
  localName: "cancelBookingPublic",
  name: "CancelBookingPublic",
  kind: MethodKind.Unary,
  I: CancelBookingPublicRequest,
  O: CancelBookingPublicResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.RejectBooking
 */
export const rejectBooking = {
  localName: "rejectBooking",
  name: "RejectBooking",
  kind: MethodKind.Unary,
  I: RejectBookingRequest,
  O: RejectBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetBookingAssignmentOptions
 */
export const getBookingAssignmentOptions = {
  localName: "getBookingAssignmentOptions",
  name: "GetBookingAssignmentOptions",
  kind: MethodKind.Unary,
  I: GetBookingAssignmentOptionsRequest,
  O: GetBookingAssignmentOptionsResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetCustomerBookings
 */
export const getCustomerBookings = {
  localName: "getCustomerBookings",
  name: "GetCustomerBookings",
  kind: MethodKind.Unary,
  I: GetCustomerBookingsRequest,
  O: GetCustomerBookingsResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.GetCustomBookingSelectionToken
 */
export const getCustomBookingSelectionToken = {
  localName: "getCustomBookingSelectionToken",
  name: "GetCustomBookingSelectionToken",
  kind: MethodKind.Unary,
  I: GetCustomBookingSelectionTokenRequest,
  O: GetCustomBookingSelectionTokenResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};

/**
 * @generated from rpc fingertip.creator.booking.v1.BookingService.VerifyCustomBooking
 */
export const verifyCustomBooking = {
  localName: "verifyCustomBooking",
  name: "VerifyCustomBooking",
  kind: MethodKind.Unary,
  I: VerifyCustomBookingRequest,
  O: VerifyCustomBookingResponse,
  service: {
    typeName: "fingertip.creator.booking.v1.BookingService"
  }
};
